/**
 * Shortest recording the session replay AI summary accepts. Shared by the sessions
 * list button and the replay player so the two cannot drift apart.
 * Keep in sync with the minimum enforced by the middleware for GENERATE_SESSION_REPLAY_SUMMARY.
 */
export const AI_SUMMARY_MIN_DURATION_MS = 10_000;

/**
 * Query param the sessions list adds when its AI Summary button opens the player:
 * the player starts the summary once the recording has loaded, then removes it.
 */
export const AI_SUMMARY_QUERY_PARAM = 'ai';
